import { AppConfig } from "../AppConfig";
import { SksdTransferResponse } from "../types/types";
import { getAGEToken } from "./authenticate";

/**
 * Transfers a nautical object to SKSD.
 * @param layerId Layer id of the nautical object
 * @param nfsFeatureGlobalId Global id of the nautical object
 * @param emailBody Optional email body. When provided, the API transfers the object by email
 *                  instead of SFTP, using this text as the body of the email.
 */
export const exportFeatureToSksd = async (
    layerId: number,
    nfsFeatureGlobalId: string,
    emailBody: string = ""
): Promise<SksdTransferResponse> => {
    let url = AppConfig.NFSAPI.BaseApiUrl + `sksd/transfer/${layerId}/${nfsFeatureGlobalId}`;
    if (emailBody !== "") {
        url += `?${new URLSearchParams({ emailBody }).toString()}`;
    }
    const token = await getAGEToken();

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
        });

        if (!response.ok && response.status !== 400) {
            const errorJson = await response.json();
            throw new Error(`HTTP error! status: ${response.status} ${errorJson}`);
        }

        const responseJson = await response.json();

        const result: SksdTransferResponse = {
            globalId: responseJson.globalId,
            layerId: responseJson.layerId,
            success: responseJson.success,
            message: responseJson.message,
            fileName: responseJson.fileName,
        };
        return result;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const resendSksdLog = async (logName: string, regenerate: boolean): Promise<SksdTransferResponse> => {
    const url = AppConfig.NFSAPI.BaseApiUrl + `sksd/transfer/resend/${logName}`;
    const token = await getAGEToken();

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({ regenerate }),
        });

        if (!response.ok && response.status !== 400) {
            const errorJson = await response.json();
            throw new Error(`HTTP error! status: ${response.status} ${errorJson}`);
        }

        const responseJson = await response.json();

        const result: SksdTransferResponse = {
            globalId: responseJson.globalId,
            layerId: responseJson.layerId,
            success: responseJson.success,
            message: responseJson.message,
            fileName: responseJson.fileName,
        };
        return result;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
